module.exports = __webpack_public_path__ + "img/2.73af6e42.jpg";